import React from "react";

const HeaderSubContent = () => {
    const emailAddress = 'cdle_dowc_provider_education@state.co.us';

    return (
        <section className="subheaderContent">
                  <h1>
          Accredited Provider Directory
        </h1>
        <p>
        This list provides the names, locations, medical specialties,
        accreditation effective and expiration dates of current Level I and
        Level II accredited providers. The “*” displayed with certain license
        numbers is for Division internal use only. This information is updated
        daily, Monday through Friday. If you have any questions, please contact the Provider
        Education Unit at { <a href={`mailto:${emailAddress}`}>{emailAddress}</a>} or
        303-318-8754.
      </p>
        <p>
             (This listing contains information for certain providers whose
          accreditation has expired within the past 20 months – shown italicized and highlighted yellow.)
        </p>
        </section>
    )
}

export default HeaderSubContent;